import React from 'react';
import * as PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { AccordionPanel } from '@reach/accordion';

import Button from '$landing-page/components/button';
import Tag from '$landing-page/components/tag';

import useStyles from './styles';

const Content = (props) => {
    const { tags, text, url } = props;

    const classes = useStyles(props);

    return (
        <AccordionPanel>
            <div className={classes.contentWrapper}>
                <Grid container direction="column" spacing={2}>
                    {tags.length > 0 && (
                        <Grid item className={classes.tagsSection}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                                Keywords
                            </Typography>
                            <div className={classes.tagsWrapper}>
                                {tags.map((tag) => (
                                    <Tag key={tag.id} name={tag.tagName} />
                                ))}
                            </div>
                        </Grid>
                    )}
                    <Grid item>
                        <Typography variant="h6" className={classes.sectionTitle}>
                            Abstract
                        </Typography>
                        <Typography variant="body2" className={classes.text}>
                            {text}
                        </Typography>
                    </Grid>
                    <Grid item container justify="flex-end">
                        <Button component="a" href={url} target="_blank">
                            Read the full text
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </AccordionPanel>
    );
};

Content.propTypes = {
    tags: PropTypes.array.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default Content;
